import { random } from 'lodash';
import {
  BLEND_MODES,
  Loader,
  Point,
  Sprite,
} from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';

class Clouds {
  constructor(parent) {
    this.parent = parent;
    this.clouds = [];
    this.lastTime = Date.now();

    this.frameHandler = () => { this.frame(); };
  }

  startSpawn() {
    ticker.add(this.frameHandler);
    this.lastTime = Date.now();
  }

  stopSpawn() {
    ticker.remove(this.frameHandler);
    for (let i = this.clouds.length - 1; i >= 0; i -= 1) {
      const cloud = this.clouds[i];
      cloud.destroy();
      this.clouds.splice(i, 1);
    }
  }

  frame() {
    for (let i = this.clouds.length - 1; i >= 0; i -= 1) {
      const cloud = this.clouds[i];
      cloud.position.y -= ticker.speed * (state.speed * 1.2);
      if (cloud.position.y < -cloud.height * 2) {
        cloud.destroy();
        this.clouds.splice(i, 1);
      }
    }

    const delay = Date.now() - this.lastTime;
    if (delay > 5000) {
      const cloud = new Sprite(Loader.shared.resources[`textures/CLOUD_${random(1, 4, false)}`].texture);
      cloud.anchor = new Point(0.5, 0);
      cloud.position.x = random(0, 375, false);
      cloud.position.y = vars.layout.FRAME_HEIGHT;
      cloud.alpha = 0.2;
      cloud.blendMode = BLEND_MODES.MULTIPLY;
      cloud.zIndex = 5;
      this.clouds.push(cloud);
      this.parent.addChild(cloud);
      this.lastTime = Date.now();
    }
  }
}

export default Clouds;
